import React from "react";
import { NavItem } from 'reactstrap';
import Menu from 'react-burger-menu/lib/menus/slide';
import NnSongMenuLink from "./NnSongMenuLink";

const skins = ['Tech', 'CandyLand', 'IrishPub', 'Christmas'];

const NnSkinMenu = ({isOpen, onChange, onClose, onKeyDown, songId, timing, letters}) => (
  <Menu id="skin-menu"
    burgerButtonClassName="no-menu-button"
    crossButtonClassName="menu-close-button"
    menuClassName={'menu'}
    itemListClassName={"menu-item-list"}
    itemClassName={"menu-item"}
    customOnKeyDown={onKeyDown}
    isOpen={isOpen}
    onStateChange={onChange}
    right
    width={'60%'}
  >
    <ul>
      {skins.map(skin =>
        <NavItem key={skin} onClick={onClose}>
          <NnSongMenuLink
            skin={skin}
            songId={songId}
            timing={timing}
            letters={letters}
          >{skin}</NnSongMenuLink>
        </NavItem>
      )}
    </ul>
  </Menu>
)
export default NnSkinMenu
